import {
    Box,
    Grid,
    Popover,
    PopoverOrigin,
    SxProps,
    Theme,
    Typography,
    styled,
} from '@mui/material'
import { useCallback } from 'react'
import Loading from 'components/Loading/Loading'

export interface IShowPosition {
    vertical?: 'bottom' | 'center' | 'top'
    horizontal?: 'left' | 'center' | 'right'
}

export interface IPopUpMenu {
    name: string
    icon?: any
    menuId: string
    isPopup?: boolean
    testIdPrefix?: string
}

export interface PopUpProps {
    isOpen: boolean
    onClose: () => void
    loading?: boolean
    children: React.ReactNode
    showPosition?: PopoverOrigin
    anchorEl: HTMLButtonElement | null
    padding?: number | string
    shadow?: number | string
    elevation?: number
    sx?: SxProps<Theme>
}

export const PopUpOverlay = styled(Box)({
    width: '100%',
    height: '100%',
    zIndex: 1202,
    backgroundColor: 'transparent',
    position: 'fixed',
})

export const PopUpBase = styled(Box)(({ theme }) => ({
    position: 'fixed',
    zIndex: 1203,
    backgroundColor: theme.palette.topside.paper,
    transition: '0.5s',
    border: theme.palette.default.main,
    borderRadius: '4px',
    padding: '24px 21px',
    maxWidth: 450,
    overflowY: 'auto',
    width: '100%',
    '@media (max-height: 450px)': {
        maxWidth: '100%',
    },
}))

function PopUp({
    isOpen = false,
    onClose = () => {},
    loading = false,
    children,
    anchorEl,
    showPosition = { vertical: 'bottom', horizontal: 'left' },
    padding = 2,
    elevation = 8,
    sx,
}: PopUpProps) {
    const handlingOnClose = useCallback(() => {
        onClose()
    }, [onClose])

    return (
        <Popover
            id="global-menu-id"
            open={isOpen}
            onClose={handlingOnClose}
            anchorOrigin={showPosition}
            anchorEl={anchorEl}
            elevation={elevation}
            sx={sx}
        >
            <Box p={padding} alignItems={'center'} justifyContent={'center'}>
                {loading ? (
                    <>
                        <Loading />
                        <Typography mt={2}>Loading Menus...</Typography>
                    </>
                ) : (
                    <Grid container>{children}</Grid>
                )}
            </Box>
        </Popover>
    )
}

export default PopUp
